import { Avatar, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing } from "components";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  },
  avatar: {
    height: 40,
    width: 40,
    marginRight: theme.spacing(2)
  },
  avatarbox: {
    display: "flex",
    flexDirection: "row"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>XP to Complete</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map((mastery, index) => (
            <TableRow key={index}>
              <TableCell className={clsx(classes.header, classes.avatarbox)}>
                <Avatar
                  className={classes.avatar}
                  src={mastery.main_image ? mastery.main_image.uri : "/images/avatars/placeholder_image.png"}
                />
                <div>
                  <div>{mastery.name_en}{mastery.name_zh ? " " + mastery.name_zh : ""}</div>
                  <div><Typography variant="caption">{mastery.code}</Typography></div>
                </div>
              </TableCell>
              <TableCell>
                {mastery.xp_complete || "0"}
                <div><Typography variant="caption">XP</Typography></div>
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/masteries/${mastery.id}/summary`} variant="outlined">
                  View
                  </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;